import React from "react";
import PortableText from "@sanity/block-content-to-react";
import createImageUrlBuilder from "@sanity/image-url";
import { createClient } from "next-sanity";
import useTranslation from "next-translate/useTranslation";
import style from "./commentReusir.module.css";
import formatUrl, { externalUrl } from "utils/FormatUrl";
import Image from "next/image";

const client = createClient({
  apiVersion: "2023-01-01",
  dataset: "production" || "production",
  projectId: "n2i0cmq4" || "",
  useCdn: false,
});

function urlFor(source) {
  return createImageUrlBuilder(client).image(source);
}

const serializer = {
  types: {
    image: (props) => (
      <div>
        <img
          src={urlFor(props.node.asset)
            .format("webp")
            .auto("format")
            .fit("clip")
            .auto("format")
            .toString()}
          alt={props.node.alt}
          className={style.imagcontent}
        />
        <figcaption>{props.node.caption}</figcaption>
      </div>
    ),
    block: (props) => {
      const { node } = props;
      switch (node.style) {
        case "h4":
          return (
            <h4 style={{ margin: "0px", marginTop: "16px" }}>
              {props.children}
            </h4>
          );
        default:
          return <span>{props.children}</span>;
      }
    },
  },
  marks: {
    color: ({ mark, children }) => (
      <span style={{ color: mark.hex }}>{children}</span>
    ),
    link: ({ children, mark }) =>
      mark.blank ? (
        <a
          style={{
            display: "flex",
            textDecoration: "underline",
            color: "rgba(70, 10, 240, 1)",
            cursor: "pointer",
            textAlign: "center",
          }}
          href={formatUrl(mark.href)}
          target="_blank"
          rel={
            externalUrl(mark.href) ||
            mark.href?.includes("list") ||
            mark.href?.includes("map") ||
            mark.href?.includes("?") ||
            mark.href?.includes("conditions") ||
            mark.href?.includes("contact")
              ? "noindex, nofollow, noreferrer"
              : "dofollow"
          }
        >
          {children}
        </a>
      ) : (
        <a
          style={{
            textDecoration: "underline",
            color: "#3498db",
            cursor: "pointer",
          }}
          href={formatUrl(mark.href)}
          rel={
            externalUrl(mark.href) ||
            mark.href?.includes("list") ||
            mark.href?.includes("map") ||
            mark.href?.includes("?") ||
            mark.href?.includes("conditions") ||
            mark.href?.includes("contact")
              ? "noindex, nofollow, noreferrer"
              : "dofollow"
          }
        >
          {children}
        </a>
      ),
    aligntexte: ({ children, mark }) =>
      mark.position == "1" ? (
        <span>{children}</span>
      ) : mark.position == "2" ? (
        <span
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            textAlign: "center",
          }}
        >
          {children}
        </span>
      ) : (
        <span
          style={{
            display: "flex",
            justifyContent: "end",
            width: "100%",
            textAlign: "end",
          }}
        >
          {children}
        </span>
      ),
  },
};
function index(props) {
  return (
    <div
      className={style.cardContainer}
      style={{
        background: props.orientation ? "white" : "rgba(0, 0, 0, 0.02)",
      }}
    >
      <div className={props.orientation ? style.cardRevers : style.card}>
        <div className={style.image}>
          {/* <img src={props.mainImage} alt={props.mainImage} /> */}
          <Image
            unoptimized
            src={props.mainImage}
            alt={props.mainImage}
            width={320}
            height={309.1}
          />
        </div>
        <div className={style.desc}>
          <div>
            <div className={style.shape}></div>
            <span className={style.title}>{props.title}</span>
            {props.body && (
              <PortableText
                projectId="n2i0cmq4"
                dataset="production"
                blocks={props.body}
                serializers={serializer}
              />
            )}
          </div>
          <div className={style.btnCon}>
            <a
              href={formatUrl(`${props.button_link}`, props.lang)}
              className={style.btnDiv}
              target="__blank"
              rel={
                externalUrl(props.button_link) ||
                props.button_link?.includes("list") ||
                props.button_link?.includes("map") ||
                props.button_link?.includes("?") ||
                props.button_link?.includes("conditions") ||
                props.button_link?.includes("contact")
                  ? "noindex, nofollow, noreferrer"
                  : "dofollow"
              }
            >
              <button className={style.btn}>{props.button_text}</button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default index;
